export default __webpack_public_path__ + "static/media/MFA T (1).3060ff9f.png";